// node-modules
import PubSub from 'pubsub-js';

// constants
import { SELECTORS } from '@/scripts/constants';
import { HERO_SLIDE_CHANGE, HERO_AUTOPLAY_STOP, HERO_AUTOPLAY_START } from '@/components/sliders';

// other
import { isMobile } from '@/scripts/helper';

// component
import Component from '../Component';


// assets
import './ClipImage.scss';

export class ClipImage extends Component {
  _splash() {
    const { toggle } = this._state;

    const { nav, social, trigger } = this._props;

    const button = trigger.querySelector('.button');

    if (nav) {
      nav.classList.toggle(SELECTORS.active, toggle);
    }

    if (social) {
      social.classList.toggle(SELECTORS.hidden, toggle);
    }

    this._element.classList.toggle(SELECTORS.active, toggle);

    if (button) {
      button.style.pointerEvents = toggle ? 'auto' : 'none';
    }
  }

  _setupEvents() {
    const { trigger } = this._props;
    const eventEnter = isMobile() ? 'click' : 'mouseenter';
    const eventLeave = 'mouseleave';
    trigger.addEventListener(eventEnter, () => {
      if (!trigger.closest('.swiper-slide-active')) { return; }
      this._setState({ toggle: true });
      this._splash();
      PubSub.publish(HERO_AUTOPLAY_STOP);
    });
    trigger.addEventListener(eventLeave, () => {
      if (!trigger.closest('.swiper-slide-active')) { return; }
      this._setState({ toggle: false });
      this._splash();
      PubSub.publish(HERO_AUTOPLAY_START);
    });

    PubSub.subscribe(HERO_SLIDE_CHANGE, () => {
      // if (!trigger.closest('.swiper-slide-active')) { return; }
      this._element.classList.remove(SELECTORS.active);
      this._setState({ toggle: false });
      this._splash();
    });
  }

  init() {
    super.init();
    this._setupEvents();
  }
}
